<template>
  <div class="admin-agency-container">
    <div v-if="!loading">
      <div v-if="showAgenciesList">
        <TopButtonsComponent
          :jobCreatorId="jobCreatorId"
          v-on:backToJobs="$emit('backToJobs', 'Jobs')"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
        />

        <div class="admin-agency-list-holder">
          <ListTable
            :headList="headList"
            :bodyList="currentJobsList"
            v-if="allAgencies"
            v-on:viewHandler="viewAgency"
            v-on:enableHandler="enableAgency"
            v-on:disableHandler="disableAgency"
            v-on:deleteHandler="deleteAgency"
          />
          <EmptyDashboardState
            v-if="!allAgencies"
            v-bind:emptyHeading="emptyStateTitle"
            v-bind:desc="jobDesc"
          />
        </div>

        <div class="pagination">
        <Pagination
          v-if="bodyList !== null"
          v-bind:itemsPerPage="itemsPerPage"
          v-bind:totalJobs="bodyList.length"
          v-bind:currentPage="currentPage"
          v-on:paginate="paginate"
        />
        </div>
      </div>

      <div v-else>
        <UserDetailsPage
          v-on:back="setView"
          :userDetailsData="userDetailsData"
        />
      </div>

      <!-- Modal component for actions confirmation -->
      <div v-if="showModal">
        <ActionModal
          :verb="modalVerb"
          :subject="modalSubject"
          v-on:modalAction="modalAction"
        />
      </div>
    </div>

    <!-- Loader Component -->
    <Loader v-if="loading" />
  </div>
</template>
<script>
import TopButtonsComponent from '../../components/JobDetail/TopButtonsComponent.vue';
import ListTable from '../../components/body/ListTable.vue';
import EmptyDashboardState from '../../components/EmptyDashboardState.vue';
import Loader from '../../components/body/Loader.vue';
import Pagination from '../../components/Pagination.vue';
import UserDetailsPage from './UserDetailsPage.vue';
import ActionModal from '../../components/Modals/ActionModal.vue';

import threeDotsIcon from '../../assets/images/tableDots.png';

export default {
  name: 'AdminAgenciesList',
  props: ['jobCreatorId'],
  components: {
    TopButtonsComponent,
    ListTable,
    EmptyDashboardState,
    Pagination,
    ActionModal,
    UserDetailsPage,
    Loader
  },
  data() {
    return {
      loading: false,
      allAgencies: null,
      jobs: null,
      userDetailsData: null,
      headList: [
        {
          text: 'AGENCIES',
        },
        {
          text: 'EMAIL',
        },
        {
          text: 'PHONE NO',
        },
        {
          text: 'TOTAL JOBS',
        },
        {
          text: 'LOCATION',
        },
        {
          text: '',
        },
      ],
      bodyList: null,
      threeDotsIcon,

      emptyStateTitle: 'Agencies',
      jobDesc: 'Agencies Not Available',
      currentPage: 1,
      itemsPerPage: 10,
      showAgenciesList: true,
      showModal: false,
      modalSubjectId: null,
      modalVerb: null,
      modalSubject: null,
    };
  },
  async mounted() {
    await this.getAllAgencies();
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },

    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },

    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
  },
  methods: {
    setView(option){
      option === 'parent'?
        this.showAgenciesList = true : this.$emit('backToPostJob', 'Post Job');
    },
    viewAgency(agencyId) {
      this.userDetailsData = this.allAgencies.find(agency => {
        return agency.id === agencyId;
      });
      this.showAgenciesList = false;
    },
    enableAgency(agencyId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = agencyId;
      this.modalVerb = 'enable';
      this.modalSubject = 'agency';
    },
    disableAgency(agencyId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = agencyId;
      this.modalVerb = 'disable';
      this.modalSubject = 'agency';
    },
    deleteAgency(agencyId) {
      this.showModal = !this.showModal;
      this.modalSubjectId = agencyId;
      this.modalVerb = 'delete';
      this.modalSubject = 'agency';
    },
    async modalAction(value) {
      //toggle modal
      this.showModal = !this.showModal;
      // decide action

      switch (true) {
        case this.modalSubject === 'agency' && this.modalVerb === 'enable':
          value === 'yes'
            ? this.sendDispatchCall('enableUser', this.modalSubjectId)
            : this.closeModal();
          break;

        case this.modalSubject === 'agency' && this.modalVerb === 'disable':
          value === 'yes'
            ? this.sendDispatchCall('disableUser', this.modalSubjectId)
            : this.closeModal();
          break;

        case this.modalSubject === 'agency' && this.modalVerb === 'delete':
          value === 'yes'
            ? this.sendDispatchCall('deleteUser', this.modalSubjectId)
            : this.closeModal();
          break;

        default:
          break;
      }
    },
    sendDispatchCall(dispatchAction, entityId) {
      this.loading = true;
      this.$store.dispatch(dispatchAction, entityId).then((res) => {
        if (res.response) {
          this.loading = false;
          this.$toastr.success(
            res.response ? res.response.message : res.response,
            'Success'
          );
          this.$router.go();
        } else if (res.error) {
          this.loading = false;
          this.$toastr.error(
            res.error.error
            ? res.error.error
            : res.error
            ? res.error.message
            : res.error,
            'Failed'
          );
        }
        this.closeModal();
      });
    },
    closeModal() {
      this.showModal = false;
      this.modalVerb = null;
      this.modalSubject = null;
      this.modalSubjectId = null;
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    },
    async getAllAgencies() {
      this.loading = true;
      await this.$store.dispatch('getAllAgencies')
      .then(() => {
        this.allAgencies = this.$store.state.allAgencies;

        // Modify each agency's data to suit table

        this.bodyList = [];
        this.allAgencies.forEach((agency) => {
          let body = {
            company: `${agency.agencyName}`,
            email: agency.emailAddress,
            phone: !agency.phone ? '—' : agency.phone,
            numberOfApplications: !agency.posts.length
              ? '0'
              : agency.posts.length,
            address: agency.city && agency.state ? `${agency.city}, ${agency.state}`
                      : agency.city ? agency.city
                      : agency.state ? agency.state
                      : '—',
            threeDotsIcon: threeDotsIcon,
            id: agency.id,
            isEnabled: agency.isEnabled,
            showDeleteButton: true
          };
          this.bodyList.push(body);
        });

        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.admin-agency-list-holder {
  background: var(--white);
  border: 0.5px solid rgba(201, 201, 201, 0.35);
  box-sizing: border-box;
  box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
  border-radius: 10px 10px;
}
.pagination {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
